const upload = [{
  desc: '批量导入人员任务文件',
  options: {
    url: '/upload/uploadSalesInfoFile',
    method: 'post'
  }
}, {
  desc: '文件上传',
  options: {
    url: '/upload/uploadSalesImageFile',
    method: 'post'
  }
}, {
  desc: '人管人员导入',
  options: {
    url: '/upload/uploadSalesInfoFile',
    method: 'post'
  }
}, {
  desc: '上传接口',
  options: {
    url: '/upload/uploadFile',
    method: 'post'
    /* headers: {
      'Content-Type': 'multipart/form-data'
    } */
  }
}, {
  desc: '下载接口',
  options: {
    url: '/upload/downloadFile',
    method: 'get',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'arraybuffer'
  }
}, {
  desc: '上传文件通用接口',
  options: {
    url: '/upload/uploadFileCommon',
    method: 'post'
  }
}]
export default upload



// WEBPACK FOOTER //
// ./src/api/upload.js